module.exports = __webpack_public_path__ + "img/skills-practiced.ef8e016a.svg";